import Chip from 'tio-reimagined/components/chip';
import { LinkTo } from '@ember/routing';
import { service } from '@ember/service';
import { t, type IntlService } from 'ember-intl';
import Component from '@glimmer/component';
import type TasProgramInstanceModel from 'tio-common/models/tas-program-instance';

export interface ProgramDescriptionSignature {
  Args: {
    instance: TasProgramInstanceModel;
  };
}

export default class ProgramDescription extends Component<ProgramDescriptionSignature> {
  @service declare intl: IntlService;

  get typeClassification() {
    return this.args.instance.typeClassification;
  }

  get isTypeTwoOrThreeProgram() {
    return (
      this.typeClassification === 'TAS.ProgramType.2' ||
      this.typeClassification === 'TAS.ProgramType.3'
    );
  }

  get programInstanceRoute() {
    // Note: Legacy tuition-assistance route removed. All programs now use TAS routes.
    return 'authenticated.tas.programs.show';
  }

  estimatedStartDate = (instance: TasProgramInstanceModel) => {
    const startDate = instance.estimatedProgramBegin as string;

    if (!startDate) return '';

    const [year, month, day] = startDate.split('-').map(Number) as [number, number, number];
    const date = new Date(year, month - 1, day);

    return this.intl.formatDate(date, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  <template>
    <div class="flex justify-between items-start">
      <div>
        <p class="font-medium flex items-center gap-x-2">
          {{#if this.isTypeTwoOrThreeProgram}}
            <p class="font-semibold text-lg">
              {{@instance.programName}}
            </p>
          {{else}}
            <LinkTo
              @route={{this.programInstanceRoute}}
              @model={{@instance.id}}
              class="font-semibold text-lg text-ocean-600 hover:underline"
            >
              {{@instance.programName}}
            </LinkTo>
          {{/if}}
          {{#unless this.isTypeTwoOrThreeProgram}}
            <Chip @intent={{@instance.badgeIntent}}>
              {{@instance.badgeLabel}}
            </Chip>
          {{/unless}}
        </p>
        <p class="font-medium">{{@instance.institutionName}}</p>
        {{#if @instance.estimatedProgramBegin}}
          <p class="text-sm">
            <span class="font-semibold">{{t "start_date"}}</span>
            {{this.estimatedStartDate @instance}}
          </p>
        {{/if}}
      </div>
    </div>
  </template>
}
